import React from 'react';

import { useQueryState } from 'hooks/useQueryState';

import { Chip } from 'components/DesignSystem/Chip';

import classes from './WidgetDataDevMode.module.scss';

interface Props {
    widgetId?: number;
    componentKey?: string;
}

// Show component key and widget id for each widget
// Works when: development mode and query param ?showWidgetData=true
export const WidgetDataDevMode = ({ widgetId, componentKey }: Props) => {
    const [showWidgetData] = useQueryState<string>('showWidgetData');
    const isDev = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';

    if (!isDev || !showWidgetData) {
        return null;
    }
    return (
        <div className={classes.widgetDataDevMode}>
            {widgetId && <Chip type={'filter'} label={`widgetId: ${widgetId}`} />}
            {componentKey && <Chip type={'filter'} label={`componentKey: ${componentKey}`} />}
        </div>
    );
};
